<template>
  <div
    class="rounded-2xl shadow-lg border-2 transition-all duration-300 hover:shadow-2xl flex flex-col relative"
    :class="[
      isCurrentPlan 
        ? 'border-primary bg-gradient-to-br from-primary to-primary-dark' 
        : 'bg-white border-gray-200 hover:border-primary'
    ]"
  >
    <div v-if="isMostPopular && !isCurrentPlan" class="absolute -top-4 left-1/2 transform -translate-x-1/2 z-10">
      <span class="bg-yellow-400 text-gray-900 px-4 py-1 rounded-full text-xs font-bold shadow-lg">
        MOST POPULAR
      </span>
    </div>
    
    <div v-if="isCurrentPlan" class="absolute -top-4 left-1/2 transform -translate-x-1/2 z-10">
      <span class="bg-white text-primary px-4 py-1 rounded-full text-xs font-bold shadow-lg border-2 border-primary">
        CURRENT PLAN
      </span>
    </div>

    <div class="p-8 flex-1 flex flex-col">
      <h3 
        class="text-2xl font-bold mb-2"
        :class="isCurrentPlan ? 'text-white' : 'text-gray-900'"
      >
        {{ product.attributes.name }}
      </h3>
      
      <!-- Plan Description -->
      <p 
        class="mb-4 font-medium"
        :class="isCurrentPlan ? 'text-white/90' : 'text-red-600'"
        v-if="planDescription"
      >
        {{ planDescription }}
      </p>
      
      <!-- Price & Button Section -->
      <div v-if="product.variants && product.variants.length" class="mb-6">
        <div
          v-for="variant in product.variants"
          :key="variant.id"
          :class="isCurrentPlan ? 'bg-white/10 border-white/20' : 'bg-gray-50 border-gray-200'"
          class="border rounded-lg p-4"
        >
          <div class="mb-4">
            <div 
              class="text-4xl font-extrabold"
              :class="isCurrentPlan ? 'text-white' : 'text-gray-900'"
            >
              {{ formatPrice(variant.attributes.price, variant.attributes.currency) }}
            </div>
            <div 
              class="text-sm mt-1"
              :class="isCurrentPlan ? 'text-white/80' : 'text-gray-500'"
            >
              per {{ variant.attributes.interval || 'month' }}
            </div>
          </div>

          <button
            v-if="!isCurrentPlan"
            @click="handleSelectPlan(variant)"
            :class="[
              'w-full py-3 px-6 rounded-lg font-semibold transition-colors duration-200',
              product.attributes.name.includes('Pro')
                ? 'bg-primary text-white hover:bg-primary-dark'
                : 'text-white bg-primary hover:bg-primary-dark'
            ]"
            :disabled="loading"
          >
            {{ isUpgrade ? 'Upgrade Now' : 'Select Plan' }}
          </button>
          
          <button
            v-else
            class="w-full py-3 px-6 rounded-lg font-semibold text-center bg-gray-200 text-gray-500 cursor-not-allowed"
            disabled
          >
            Current Plan
          </button>
        </div>
      </div>
      
      <!-- Description -->
      <p 
        class="mb-6"
        :class="isCurrentPlan ? 'text-white/90' : 'text-gray-600'"
        v-if="descriptionText"
        v-html="descriptionText"
      ></p>

      <!-- Features List -->
      <ul v-if="features.length" class="space-y-3 mb-8 flex-1">
        <li v-for="feature in features" :key="feature" class="flex items-start">
          <span 
            class="material-symbols-outlined mr-2 text-xl"
            :class="isCurrentPlan ? 'text-yellow-400' : 'text-green-500'"
          >
            check_circle
          </span>
          <span :class="isCurrentPlan ? 'text-white' : 'text-gray-700'">
            {{ feature }}
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PremiumPlanCard',
  props: {
    product: {
      type: Object,
      required: true
    },
    isCurrentPlan: {
      type: Boolean,
      default: false
    },
    isMostPopular: {
      type: Boolean,
      default: false
    },
    planDescription: {
      type: String,
      default: ''
    },
    isUpgrade: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['select-plan'],
  computed: {
    features() {
      if (this.product.attributes.features && Array.isArray(this.product.attributes.features) && this.product.attributes.features.length) {
        return this.product.attributes.features;
      }
      if (this.product.attributes.description) {
        let text = this.product.attributes.description.replace(/<\/?p>/g, '\n').replace(/<br\s*\/?>/g, '\n');
        return text.split('\n')
          .map(line => line.trim())
          .filter(line => /^- /.test(line))
          .map(line => line.replace(/^- /, '').trim());
      }
      return [];
    },
    descriptionText() {
      if (!this.product.attributes.description) return '';
      let text = this.product.attributes.description.replace(/<p>-.*?<\/p>/g, '');
      text = text.split('\n').filter(line => !/^- /.test(line.trim())).join('\n');
      text = text.replace(/<p>\s*<\/p>/g, '');
      return text.trim();
    }
  },
  methods: {
    formatPrice(price, currency = 'USD') {
      if (!price) return 'Free';
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency
      }).format(price / 100);
    },
    handleSelectPlan(variant) {
      this.$emit('select-plan', this.product, variant);
    }
  }
};
</script>
